import {Component, inject, OnInit} from "@angular/core";
import {Router} from "@angular/router";

@Component({
  selector: 'app-callback',
  standalone: true,
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss'
})
export class CallbackComponent implements OnInit {
  router = inject(Router);

  constructor() {
    console.log("callback called.");
  }

  ngOnInit(): void {
  }
}
